module.exports = __webpack_public_path__ + "static/media/Satisfy-Regular.aaa5880c.ttf";